export const robots = [
	{
		id: 1,
		name: 'Paul Allen',
		username: 'Allen',
		email: 'allen@vice.pres'
	},
	{
		id: 2,
		name: 'Patrick Bateman',
		username: 'Bateman',
		email: 'batman@vice.pres'
	},
	{
		id: 3,
		name: 'William Wallace',
		username: 'Wallace',
		email: 'wallace@scot.uk'
	},
	{
		id: 4,
		name: 'Catherine Lorna',
		username: 'Lorna',
		email: 'lorna@may.fi'
	},
	{
	    id: 5,
	    name: 'Beth Janet',
	    username: 'Janet',
	    email: 'janet@clorance.ca'
	},
	{
	    id: 6,
	    name: 'Jack Frost',
	    username: 'keaton',
	    email: 'jack@frost.info'
	},
	{
	    id: 7,
	    name: 'Alex Pruitt',
	    username: 'pruitt',
	    email: 'alex@home.again'
	},
	{
	    id: 8,
	    name: 'Clark Griswold',
	    username: 'Griswold',
	    email: 'griswold@lampoon.vac'
	},
	{
	    id: 9,
	    name: 'Neal Oliver',
	    username: 'neal',
	    email: 'oliver@interstate.io'
	},
	{
	    id: 10,
	    name: 'Leon Black',
	    username: 'larry',
	    email: 'curb@it.io'
	}
];